import React from 'react';
import {Grid, IconButton, InputAdornment, styled, Typography} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const AlignCenterGrid = styled(Grid)(() => ({
  alignSelf: 'center',
}));

const AlignCenterHideOnSmallScreen = styled(AlignCenterGrid)(({theme}) => ({
  // Hide on small screens below the medium breakpoint
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));

const PlacesAutocompleteInputAdornmentEnd = (props) => {
  const {searchValue, showFilters, onCancelIconClick, onFiltersIconClick} = props;

  return <InputAdornment position={'end'}>
    {
      searchValue && <Grid container direction={'row'} wrap={'nowrap'} justifyContent={'center'} spacing={1}>
          <AlignCenterHideOnSmallScreen item>
            <Typography variant={'overline'}>Hit Enter to Search</Typography>
          </AlignCenterHideOnSmallScreen>
          <AlignCenterGrid item>
            <KeyboardReturnIcon fontSize={'small'} color={'primary'}/>
          </AlignCenterGrid>
        {
          !showFilters && <AlignCenterGrid item>
            <IconButton onClick={onFiltersIconClick} color={'primary'}>
              <ArrowDropDownIcon fontSize={'large'} />
            </IconButton>
          </AlignCenterGrid> || <AlignCenterGrid item>
            <IconButton onClick={onFiltersIconClick} color={'primary'}>
              <ArrowDropUpIcon fontSize={'large'} />
            </IconButton>
          </AlignCenterGrid>
        }
        <AlignCenterGrid item>
          <IconButton onClick={onCancelIconClick} color={'primary'}>
            <CancelIcon fontSize='small' />
          </IconButton>
        </AlignCenterGrid>
      </Grid>
    }
  </InputAdornment>
}

export default PlacesAutocompleteInputAdornmentEnd;
